export default __webpack_public_path__ + "static/media/600-700.cc3209a5.jpg";